
<div class="dialog">
    <div mat-dialog-title>{{action}}<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
    <mat-dialog-content>
        <div class="block">
            <label>Title*</label>
            <irb-validation-text-box #titleField [(value)]="data.messageTitle" max="100" (change)="onInputChange()" regExp="^[a-zA-Z0-9\:\;\?\<\>\,\.\-\!\$\&\(\)\* ]+$" invalidMessage="The value entered is not valid." width="420px" autofocus="true"></irb-validation-text-box>
        </div>
        <div class="block">
            <p-checkbox name="active" [(ngModel)]="data.isActive" binary="true" (onChange)="onInputChange(); warnOnInvalidExpirationDate();" class="announcement-is-active-chk"></p-checkbox>&nbsp;<label>Active</label>
            <label>Expiration</label>

            <div class="mat-datepicker-container">
                <input matInput [min]="minDate" [matDatepicker]="picker" class="date-control" [(ngModel)]="expirationDate" (dateChange)="onInputChange()">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </div>
        </div>
        <div class="hblock">
            <label>Announcement Text*</label>
        </div>
        <div>
            <irb-text-editor [(text)]="data.messageText" (change)="onInputChange()"></irb-text-editor>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
        <button id="previewButton" (click)="preview()" class="btn-medium-secondary" [disabled]="!isValid">Preview</button>
        <button id="continueButton" (click)="continue()" class="btn-medium-primary" [disabled]="!isModified || !isValid">{{action}}</button>
    </mat-dialog-actions>
</div>
